import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getSession, validateKey } from "../../utils/auth";
import z from "zod";

const searchSchema = z.object({
  key: z.string().optional(),
});

export const Route = createFileRoute("/preview")({
  component: RouteComponent,
  validateSearch: searchSchema,
  beforeLoad: async ({ search: { key } }) => {
    if (key) {
      const validKey = await validateKey({ data: { key } });
      if (!validKey) throw redirect({ to: "/" });
    } else {
      const session = await getSession();
      if (!session) throw redirect({ to: "/" });
    }
    return { key };
  },
});

function RouteComponent() {
  return <Outlet />;
}
